import React from 'react'
import { trans } from '../../../../_providers/Translation'
import DateRange from '@/components/partials/DateRange'

function Filter(props) {

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleDate = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleClearFilters = () => {
        props.handleSearch('text', '')
        props.handleSearch('method', '')
        props.handleSearch('date', '')
        props.handleSearch('deadline', '')
    }

    return (
        <form className="filter-standard schedule-filter">
            <div className="col">
                <input
                    id="search"
                    type="search"
                    name="text"
                    value={props.data.text}
                    onChange={handleSearch}
                    placeholder={trans('filters.search')}
                />
            </div>
            <div className="col">
                <select
                    id="method"
                    name="method"
                    value={props.data.method}
                    onChange={handleSearch}
                >
                    <option value="">
                        Всички типове
                    </option>
                    <option value="sms">
                        SMS
                    </option>
                    <option value="email">
                        Email
                    </option>
                </select>
            </div>
            <div className="col">
                <DateRange
                    startDate={props.data.date}
                    endDate={props.data.deadline}
                    onStartDateChange={(date) => {
                        props.handleSearch('date', date)
                    }} onEndDateChange={(date) => {
                        props.handleSearch('deadline', date)
                    }}
                />
            </div>
            <div className='col'>
                <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                    Изчистване
                </button>
            </div>
        </form>
    )
}

export default Filter